export const errorChecker = (isPending: boolean, isError: boolean, data: any) =>
  isError
    ? "خطا در دریافت اطلاعات کاربر "
    : isPending
    ? "در حال بارگیری"
    : data;
